export default __webpack_public_path__ + "static/media/google-meeting-camera.bca26d1c.svg";